import { Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import getAvailability from "../../../api/auth/items/getAvailability";
import { addDays, format } from "date-fns";
import { CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import WushTextField from "../WushTextField";

export default function ItemAvailability({item}) {
  const [startDate, setStartDate] = useState(format(new Date(), 'yyyy-MM-dd'));
  const [endDate, setEndDate] = useState(format(addDays(new Date(), 7), 'yyyy-MM-dd'));
  const [availability, setAvailability] = useState();

  useEffect(() => {
    getAvailability(item.id, startDate, endDate, (response) => {
      setAvailability(response);
    });
  }, [startDate, endDate, item.stock]);

  const mapData = () => {
    return Object.keys(availability).map((key) => (
      {
        name: key,
        available: availability[key]
      }
    ));
  };

  if(!availability) return null;

  return (
    <Stack height="500px">
      <Stack mb={1}>
        <Typography variant="h5">
          Item Availability
        </Typography>
      </Stack>
      <Stack direction="row" spacing={2} mb={2}>
        <WushTextField label="Start Date" type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
        <WushTextField label="End Date" type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
      </Stack>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart title="Availability" key={'available'} width={1000} height={250} data={mapData()} margin={{ right: 30 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Line type="monotone" dataKey={'available'} stroke="#8884d8" />
        </LineChart>
      </ResponsiveContainer>
    </Stack>
  );
}